export default {"src":"/_next/static/media/dark-check-outline.85b79e7c.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};